// extracted by mini-css-extract-plugin
export default {"fullWidth":"oo-z","image":"po-z","lazyLoadPicture":"qo-z","lazyLoadSpinner":"ro-z","lazyLoadSpin":"so-z","lazyLoadImage":"to-z","hasStyledAspectRatio":"uo-z"};